<div
  class="relative overflow-hidden flex items-center border rounded w-[100px] bg-surface"
  [class]="containerClasses()"
  [style.border-color]="borderColor()"
>
  <div
    class="h-full overflow-hidden"
    [class]="barClasses()"
    [style.background-color]="color()"
    [style.transition]="transitionStyle()"
    [style.width]="animatedWidth()"
  ></div>
  @if (showPercentage()) {
    <span
      class="absolute inset-0 flex items-center justify-center z-10 md:text-sm text-xs"
      [class]="textClasses()"
    >
      {{ coverage() | number }}%
    </span>
  }
</div>
